module.exports = __webpack_public_path__ + "static/media/icon-comprehensive- assessment.f7289621.svg";